import React, { useState } from 'react';
import axios from 'axios';
import { DataGrid } from '@material-ui/data-grid';
import { CircularProgress } from '@material-ui/core';
import styles from './styles';
import { API_URL_JOBS, API_KEY_JOBS } from '../../constants';

const ActivityLog = ({ builderId }) => {
  const classes = styles.useStyles();
  const { style } = styles;
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const getDateTime = timestamp => {
    const IST = new Date(timestamp);
    return `${IST.getDate()}/${IST.getMonth() +
      1}/${IST.getFullYear()}     ${IST.getHours()}:${
      IST.getMinutes() < 10 ? '0' : ''
    }${IST.getMinutes()}`;
  };

  const headers = {
    'Content-Type': 'application/json',
    'x-api-key': `${API_KEY_JOBS}`,
  };
  const getActivityLogs = () => {
    axios(`${API_URL_JOBS}/activityLog/${builderId}`, { headers })
      .then(res => {
        if (Array.isArray(res.data)) {
          setLogs(
            res.data.map(log => ({
              id: log.id,
              dateTime: getDateTime(log.created_at),
              user: `${log.username} ${
                log.changedBy === 'Admin' ? '(Admin)' : ''
              }`,
              activity: log.activityName,
            })),
          );
        }
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        setLoading(false);
        console.log({ err });
      });
  };
  React.useEffect(() => {
    getActivityLogs();
  }, []);

  const columns = [
    { field: 'dateTime', headerName: 'Date & Time', flex: 1 },
    {
      field: 'activity',
      headerName: 'Activity',
      flex: 1,
    },
    {
      field: 'user',
      headerName: 'User',
      flex: 1,
    },
  ];

  if (loading)
    return (
      <div style={style.loadingWrapper}>
        <CircularProgress size={40} />
      </div>
    );
  if (error) return <h3>There&apos;s an error! Please try again later.</h3>;
  return (
    <div>
      {logs && logs.length >= 1 ? (
        <DataGrid
          className={classes.root}
          rows={logs}
          columns={columns}
          pageSize={10}
          disableColumnMenu
          disableColumnSelector
          density="comfortable"
          disableSelectionOnClick
          autoHeight
        />
      ) : (
        <h3>No Logs Present!</h3>
      )}
    </div>
  );
};

export default ActivityLog;
